import { render, staticRenderFns } from "./financialStatic.vue?vue&type=template&id=587886e2&scoped=true&"
import script from "./financialStatic.vue?vue&type=script&lang=js&"
export * from "./financialStatic.vue?vue&type=script&lang=js&"
import style0 from "./financialStatic.vue?vue&type=style&index=0&id=587886e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587886e2",
  null
  
)

export default component.exports